module.exports = __webpack_public_path__ + "static/media/Mask Group 20.13145d8c.svg";